import React, { useContext, useState } from 'react';
import { Store } from '../../Store'
import { IdObj } from '../../utils/interface';

import './QuoteAttachmentOptions.css'

interface QuoteAttachmentOptionsProps {
  id: number;
  displayTrigger: boolean;
  listItems: Array<{
    img: string;
    text: string;
    onclick?(id:number): void;
  }>
}




function QuoteAttachmentOptions(props: QuoteAttachmentOptionsProps) {

  return (
    <div className='actionToolTip' style={props.displayTrigger ? { display: "flex" } : { display: "none" }}>
      <div className='action-icons'>
        {
          props.listItems.map((obj, i) => {
            return (

              <div className='action-iconitem' onMouseDown={() => obj.onclick!(props.id)} key={i}>
                <img id={obj.text + "-img-" + props.id} className='action-icon' alt={obj.text} src={obj.img}
                  onMouseEnter={() => {
                    let text = document.getElementById(obj.text + "-text-" + props.id)
                    if (text) {
                      text.classList.add("actionTextHover")
                    }
                    let img = document.getElementById(obj.text + "-img-" + props.id)
                    if (img) {
                      img.classList.add("actionIconHover")
                    }
                  }}
                  onMouseLeave={() => {
                    let text = document.getElementById(obj.text + "-text-" + props.id)
                    if (text) {
                      text.classList.remove("actionTextHover")
                    }
                    let img = document.getElementById(obj.text + "-img-" + props.id)
                    if (img) {
                      img.classList.remove("actionIconHover")
                    }
                  }}
                />
              </div>
            )
          })
        }
      </div>
      <div className='action-content'>
        {
          props.listItems.map((obj, i) => {
            return (
              <div className='action-item' onMouseDown={() => obj.onclick!(props.id)} key={i}>
                <span id={obj.text + "-text-" + props.id} className='action-text' onMouseEnter={() => {
                  let text = document.getElementById(obj.text + "-text-" + props.id)
                  if (text) {
                    text.classList.add("actionTextHover")
                  }
                  let img = document.getElementById(obj.text + "-img-" + props.id)
                  if (img) {
                    img.classList.add("actionIconHover")
                  }
                }}
                  onMouseLeave={() => {
                    let text = document.getElementById(obj.text + "-text-" + props.id)
                    if (text) {
                      text.classList.remove("actionTextHover")
                    }
                    let img = document.getElementById(obj.text + "-img-" + props.id)
                    if (img) {
                      img.classList.remove("actionIconHover")
                    }
                  }}
                >{obj.text}</span>
              </div>
            )
          })
        }
      </div>
    </div>
  );
}

export default QuoteAttachmentOptions;
